import React from 'react'
import { connect } from 'react-redux'
import MarkupActions from '../../Redux/MarkupRedux'
import FormatMoney from '../../Utils/FormatMoney'
import PrecisionRound from '../../Utils/PrecisionRound'
import Modal from 'react-responsive-modal'
import Tooltip from 'react-tooltip'
// import AdvancedTable from '../../Components/AdvancedTable'

class ComparisonDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedUUID: '',
      form: {
        markup_price_id: props.detail.id,
        attraction_package_id: '',
        value: 0
      },
      detail: {},
      showModal: null
    }
  }

  componentDidMount = () => {
    this._getMarkupItem(this.props.detail.id)
  }

  _getMarkupItem = (id) => {
    let data = { id }
    this.props.markupItemGet(data)
  }

  _precisionRound = (args) => {
    return PrecisionRound((args - 1) * 100)
  }

  _precisionBadge = (value, clickable, item) => {
    if (!clickable) {
      return (
        <span className={`badge badge-${value > 1 ? 'success' : (value === 1 ? 'light' : 'danger')}`}>
          { value > 1 && '+' } { this._precisionRound(value) } %
        </span>
      )
    } else {
      return (
        <span data-tip={'Click to change value'} role='button' onClick={() => this._selectItem(item, 'update', 'modal-update')} className={`badge badge-${value > 1 ? 'success' : (value === 1 ? 'light' : 'danger')}`}>
          <Tooltip />
          { value > 1 && '+' } { this._precisionRound(value) } %
        </span>
      )
    }
  }

  _availabilityParse = (prev) => {
    if (prev !== null) {
      return <span>{FormatMoney(prev)}</span>
    } else {
      return 'Unavailable'
    }
  }

  _packageParse = (args) => {
    return (args.is_disabled && args.is_expired)
      ? 'Disabled & Expired'
      : args.is_disabled
        ? 'Disabled'
        : 'Expired'
  }

  _attractionParse = (args) => {
    return (
      <div className='text-center'>
        <h4>
          {`Attraction ${(args.is_disabled && args.is_expired) ? 'Disabled & Expired' : args.is_disabled ? 'Disabled' : 'Expired'}`}
        </h4>
      </div>
    )
  }

  _renderItemButton = (item, text, method, modalID, buttonStyle, iconStyle) => {
    return (
      <button className={`btn ${buttonStyle}`} onClick={() => this._selectItem(item, method, modalID)}>
        <i className={`fa ${iconStyle}`} /> {text}
      </button>
    )
  }

  _selectItem = (item, method, modalID) => {
    if (method === 'create') {
      let value = item.id
      let form = { ...this.state.form }
      form.attraction_package_id = value
      this.setState({ detail: item, form })
    } else if (method === 'update') {
      let form = { ...this.state.form }
      form.value = this._precisionRound(item.markup_item_price.value)
      let selectedUUID = item.markup_item_price.id
      this.setState({ detail: item, form, selectedUUID })
    } else if (method === 'delete') {
      let selectedUUID = item.markup_item_price.id
      this.setState({ detail: item, selectedUUID })
    }
    this._toggleModal(modalID)
  }

  _toggleModal = (modalID, postAction) => {
    if (postAction) {
      this._getMarkupItem(this.props.detail.id)
    }
    if (!modalID) {
      let form = {
        markup_price_id: this.props.detail.id,
        attraction_package_id: '',
        value: 0
      }
      this.setState({ showModal: modalID, form, detail: {} })
    } else {
      this.setState({ showModal: modalID })
    }
  }

  _determineRender = (provider, ATTRACTION_PACKAGES) => {
    switch (provider) {
      case 'BMG':
        return this._renderBMG(ATTRACTION_PACKAGES)
      case 'KLOOK':
        return this._renderKLOOK(ATTRACTION_PACKAGES)
      default:
        return null
    }
  }

  _handleChange = (event, field) => {
    let form = { ...this.state.form }
    let value = event.target.value
    if (field === 'value') {
      if (parseFloat(value) > 100) {
        value = 100
      } else if (parseFloat(value) < -100) {
        value = -100
      }
    }
    form[field] = value
    this.setState({ form })
  }

  _markupItemCreate = (event) => {
    if (event) {
      event.preventDefault()
    }
    let form = { ...this.state.form }
    form.value = (form.value / 100) + 1
    let data = { form }
    this.props.markupItemCreate(data)
    setTimeout(() => {
      this._toggleModal(null, true)
    }, 300)
  }

  _markupItemUpdate = (event) => {
    if (event) {
      event.preventDefault()
    }
    let form = { ...this.state.form }
    form.value = (form.value / 100) + 1
    let data = {
      uuid: this.state.selectedUUID,
      form
    }
    this.props.markupItemUpdate(data)
    setTimeout(() => {
      this._toggleModal(null, true)
    }, 300)
  }

  _markupItemDelete = () => {
    let data = { uuid: this.state.selectedUUID }
    this.props.markupItemDelete(data)
    setTimeout(() => {
      this._toggleModal(null, true)
    }, 300)
  }

  _renderBMG = (ATTRACTION_PACKAGES) => {
    return (
      <section className='card'>
        <table className='table table-striped table-hover'>
          <thead>
            <tr>
              <th style={{ minWidth: '300px' }}>Package Name</th>
              <th className='text-center'>Package Markup Value</th>
              <th className='text-center'>Adults</th>
              <th className='text-center'>Children</th>
              <th className='text-center'>Senior</th>
              <th className='text-center'>Manage</th>
            </tr>
          </thead>
          <tbody>
            {
              ATTRACTION_PACKAGES.length > 0
                ? ATTRACTION_PACKAGES.map((item, i) => (
                  <tr key={i}>
                    <td style={{ width: '300px' }}>{item.title || '-'}</td>
                    <td className='text-center'>
                      {
                        item.markup_item_price !== null
                          ? this._precisionBadge(item.markup_item_price.value, true, item)
                          : 'Not set'
                      }
                    </td>
                    <td className='text-center'>
                      {
                        (!item.is_disabled && !item.is_expired)
                          ? this._availabilityParse(item.prices.adults)
                          : this._packageParse(item)
                      }
                    </td>
                    <td className='text-center'>
                      {
                        (!item.is_disabled && !item.is_expired)
                          ? this._availabilityParse(item.prices.children)
                          : this._packageParse(item)
                      }
                    </td>
                    <td className='text-center'>
                      {
                        (!item.is_disabled && !item.is_expired)
                          ? this._availabilityParse(item.prices.seniors)
                          : this._packageParse(item)
                      }
                    </td>
                    <td className='text-center'>
                      { !item.markup_item_price && this._renderItemButton(item, 'Set', 'create', 'modal-create', 'btn-primary', 'fa-plus') }
                      { item.markup_item_price && this._renderItemButton(item, 'Remove', 'delete', 'modal-delete', 'btn-danger', 'fa-trash') }
                    </td>
                  </tr>
                ))
                : <tr>
                  <td className='text-center' colSpan='6'>-No Data-</td>
                </tr>
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderKLOOK = (ATTRACTION_PACKAGES) => {
    return (
      <section className='card'>
        <table className='table table-striped table-hover'>
          <thead>
            <tr>
              <th style={{ width: '30%' }}>Attraction Name</th>
              <th className='text-center'>Package Markup Value</th>
              <th>Package Price</th>
              <th className='text-center'>Manage</th>
            </tr>
          </thead>
          <tbody>
            {
              ATTRACTION_PACKAGES.length > 0
                ? ATTRACTION_PACKAGES.map((item, i) => (
                  <tr key={i}>
                    <td style={{ width: '30%' }}>{item.title}</td>
                    <td className='text-center'>
                      {
                        item.markup_item_price !== null
                          ? this._precisionBadge(item.markup_item_price.value, true, item)
                          : 'Not Set'
                      }
                    </td>
                    <td>
                      <ul>
                        {
                          item.prices.map((x, y) => (
                            <li key={y}>
                              <strong>{x.name}:</strong> {FormatMoney(x.price)}
                            </li>
                          ))
                        }
                      </ul>
                    </td>
                    <td className='text-center'>
                      { !item.markup_item_price && this._renderItemButton(item, 'Set', 'create', 'modal-create', 'btn-primary', 'fa-plus') }
                      { item.markup_item_price && this._renderItemButton(item, 'Remove', 'delete', 'modal-delete', 'btn-danger', 'fa-trash') }
                    </td>
                  </tr>
                ))
                : <tr>
                  <td colSpan='4' className='text-center'>- No Data-</td>
                </tr>
            }
          </tbody>
        </table>
      </section>
    )
  }

  render () {
    const { detail, markup } = this.props
    const { data_item } = markup
    return (
      <section className='section' style={{ width: '90vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Package Markup
            <p className='title-description ml-2'>{ detail.attraction.title } ({detail.attraction.provider}) </p>
          </h4>
        </div>

        <table className='mb-3' style={{ width: '30%' }}>
          <tbody>
            <tr>
              <td><strong>Base Markup Value</strong></td>
              <td>
                { this._precisionBadge(data_item.value, false, null) }
              </td>
            </tr>
          </tbody>
        </table>

        {
          data_item !== null &&
          (!data_item.attraction.is_disabled && !data_item.attraction.is_expired)
            ? this._determineRender(data_item.attraction.provider, data_item.attraction.attraction_packages)
            : this._attractionParse(data_item.attraction)
        }

        <div className='form-group text-right'>
          <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
        </div>

        {/* MODAL-CREATE */}
        <Modal center open={this.state.showModal === 'modal-create'} onClose={() => this._toggleModal(null)}>
          <section className='section' style={{ width: '35vw' }}>
            <div className='title-block'>
              <h1 className='title mr-auto'>Create Package Markup</h1>
              <p className='title-description ml-1'>{this.state.detail.title} ({this.state.detail.provider})</p>
            </div>
            <form onSubmit={(event) => this._markupItemCreate(event)}>
              <div className='form-group'>
                <label className='control-label'>Package Markup Value</label>
                <div className='input-group'>
                  <input type='number' required step='any' max={100} className='form-control' value={this.state.form.value} onChange={(event) => this._handleChange(event, 'value')} />
                  <div className='input-group-append'>
                    <span className='input-group-text'>%</span>
                  </div>
                </div>
              </div>
              <div className='form-group text-right'>
                <button className='btn btn-secondary mr-2' type='button' onClick={() => this._toggleModal(null)}>Cancel</button>
                <button className='btn btn-primary' type='submit'>Submit</button>
              </div>
            </form>
          </section>
        </Modal>

        {/* MODAL-UPDATE */}
        <Modal center open={this.state.showModal === 'modal-update'} onClose={() => this._toggleModal(null)}>
          <section className='section' style={{ width: '35vw' }}>
            <div className='title-block'>
              <h1 className='title mr-auto'>Update Package Markup</h1>
              <p className='title-description ml-1'>{this.state.detail.title} ({this.state.detail.provider})</p>
            </div>
            <form onSubmit={(event) => this._markupItemUpdate(event)}>
              <div className='form-group'>
                <label className='control-label'>Package Markup Value</label>
                <div className='input-group'>
                  <input type='number' required step='any' max={100} className='form-control' value={this.state.form.value} onChange={(event) => this._handleChange(event, 'value')} />
                  <div className='input-group-append'>
                    <span className='input-group-text'>%</span>
                  </div>
                </div>
              </div>
              <div className='form-group text-right'>
                <button className='btn btn-secondary mr-2' type='button' onClick={() => this._toggleModal(null)}>Cancel</button>
                <button className='btn btn-primary' type='submit'>Save</button>
              </div>
            </form>
          </section>
        </Modal>

        {/* MODAL-DELETE */}
        <Modal center open={this.state.showModal === 'modal-delete'} onClose={() => this._toggleModal(null)}>
          <section className='section' style={{ width: '35vw' }}>
            <div className='title-block'>
              <h1 className='title mr-auto'>Remove Package Markup</h1>
            </div>
            <div className='text-center'>
              {
                this.state.detail.markup_item_price &&
                <p>{this.state.detail.title} ({this.state.detail.provider}) {this._precisionBadge(this.state.detail.markup_item_price.value, false)}</p>
              }
            </div>
            <div className='form-group text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this._toggleModal(null)}>Cancel</button>
              <button type='button' className='btn btn-danger' onClick={() => this._markupItemDelete()}><i className='fa fa-trash mr-2' />Remove</button>
            </div>
          </section>
        </Modal>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  markup: state.markup
})

const dispatchToProps = (dispatch) => ({
  updateMarkup: (data) => dispatch(MarkupActions.markupUpdateRequest(data)),
  markupItemCreate: (data) => dispatch(MarkupActions.markupItemCreateRequest(data)),
  markupItemUpdate: (data) => dispatch(MarkupActions.markupItemUpdateRequest(data)),
  markupItemDelete: (data) => dispatch(MarkupActions.markupItemDeleteRequest(data)),
  markupItemGet: (data) => dispatch(MarkupActions.markupItemGetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ComparisonDetails)



// WEBPACK FOOTER //
// ./src/Containers/Markup/ComparisonDetails.js